



































import ApiClient from '@/js/api.js'
import PopupTemplate from '@/views/templates/africadogs/PopupTemplate.vue'

export default
  components: {
    PopupTemplate
  }

  props: {
    point_code:
      type: String
      default: ''
    first_title:
      type: String
      default: ''
    second_title:
      type: String
      default: ''
    point_image:
      type: String
      default: ''
    title:
      type: String
      default: ''
    image_number:
      type: Number
      default: 0
    message:
      type: Array
      default: []
    youtube:
      type: String
      default: ''
    movie_mode:
      type: String
      default: 'yoko'
  }

  data: () ->
    point: 0

  created: () ->
    api = new ApiClient()
    param =
      'point_code': @point_code
    data = await api.post('/member/point/save', true, param)
    @point = data.point
    if @point > 0
      @$emit('addPoint', @point)

  methods: {
    closePopup: () ->
      @$emit('closePopup')
  }
